import { Contain } from "@components/layout";
import useEnforceLoggedIn from "@hooks/useEnforceLoggedIn";
import { getWordpressVars } from "@lib/wordpressVars";
import DownloadBar from "@ppPartials/download-bar";
import {
    useGetPartnerPortalFinalOrderCutOffIssuesQuery,
    useGetPartnerPortalNewReleaseIssuesQuery
} from "@ppServices/Issue";
import {
    useGetPartnerDataQuery,
    useGetPartnerExportableFieldsQuery,
} from "@ppServices/Partners";
import { Layout, Tabs } from "antd";
import { useEffect, useState } from "react";
import { Helmet as Head } from "react-helmet-async";
import IssueDataSection from "src/partner-portal/components/issue-data-section";
import _ from "underscore";
import Header from "../../partials/header";
import MainNav from "../../partials/main-nav";

const Home = () => {

    const { user, isSuccess } = useEnforceLoggedIn();

    const { title } = getWordpressVars();

    const [main, setMain] = useState<any>({});

    const [activeTab, setActiveTab] = useState('NewRelease');

    const [dateFocSelect, setDateFocSelect] = useState([]);

    const [dateNewReleaseSelect, setDateNewReleaseSelect] = useState([]);

    const [issueIds, setIssueIds] = useState([]);

    const [issueDate, setIssueDate] = useState('');

    const [fieldsOptons, setFieldOptions] = useState([]);

    const [activeElements, setActiveElements] = useState<any>();

    const exportableFieldsQuery = useGetPartnerExportableFieldsQuery({
        userId: user?.id
    }, { skip: !isSuccess });

    const userDataByIdQuery = useGetPartnerDataQuery({
        userId: user?.id
    }, { skip: !isSuccess });

    useEffect(() => {
        if (userDataByIdQuery.data) {
            setMain(userDataByIdQuery.data);
            setDateNewReleaseSelect(userDataByIdQuery.data?.newReleaseOptions);
            setDateFocSelect(userDataByIdQuery.data?.focWeeksOptions);
        }

    }, [userDataByIdQuery.data]);

    useEffect(() => {
        if (exportableFieldsQuery.data) {
            setFieldOptions(exportableFieldsQuery.data?.options);
        }

    }, [exportableFieldsQuery.data]);

    const handleTabChange = (tabKey: string) => {
        if (tabKey !== activeTab)
            setActiveTab(tabKey);
    };

    const handelSectionChange = ({ tab, dateSelect, ids }) => {
        if (tab === activeTab) {
            let selectedOrfiltered = ids.filtered?.length > 0
                ? ids.filtered
                : ids.selected

            if (!_.isEqual(_.sortBy(selectedOrfiltered), _.sortBy(issueIds)))
                setIssueIds(selectedOrfiltered);

            if (dateSelect?.middle !== issueDate)
                setIssueDate(dateSelect?.middle);
        }
    };

    const handleFilterChange = (activeElements) => {
        setActiveElements(activeElements);
    }

    const handleDownloadSuccess = (status) => {
        if (status) {
            userDataByIdQuery.refetch();
        }
    }

    return (
        <Layout className="pp-home-page">

            <Head>
                <title>{title} - CovrPrice</title>
            </Head>

            <MainNav />

            <Header
                partnerLogoUrl={main?.partner?.partnerLogoUrl}
                partnerHelpInfo={main?.customerServiceRep}
            />

            <Contain>

                <DownloadBar
                    onDownloadSuccess={handleDownloadSuccess}
                    isLoading={
                        userDataByIdQuery.isLoading ||
                        userDataByIdQuery.isFetching
                    }
                    lastDownloadedFile={main?.lastDownloadedFiles}
                    fieldsOptons={fieldsOptons}
                    onFilterChange={handleFilterChange}
                    date={issueDate}
                    ids={issueIds}
                    type={activeTab}
                />

                <Tabs
                    activeKey={activeTab}
                    onChange={handleTabChange}
                    defaultActiveKey="NewRelease"
                    items={[
                        {
                            key: 'NewRelease',
                            label: 'New Releases',
                            children:
                                <IssueDataSection
                                    queryFunc={useGetPartnerPortalNewReleaseIssuesQuery}
                                    onDataChange={(obj) => handelSectionChange({
                                        tab: 'NewRelease', ...obj
                                    })}
                                    dateOptions={dateNewReleaseSelect}
                                    activeElements={activeElements}
                                    setActiveElements={setActiveElements}
                                />,
                        },
                        {
                            key: 'FOC',
                            label: 'FOC',
                            children:
                                <IssueDataSection
                                    queryFunc={useGetPartnerPortalFinalOrderCutOffIssuesQuery}
                                    onDataChange={(obj) => handelSectionChange({
                                        tab: 'FOC', ...obj
                                    })}
                                    dateOptions={dateFocSelect}
                                    activeElements={activeElements}
                                    setActiveElements={setActiveElements}
                                />,
                        },
                    ]}
                />

            </Contain>

        </Layout>
    );
};

export default Home;
